import * as z from "zod/v4";

const DiffValuesSchema_ = z.record(
  z.string(),
  z
    .union([
      z.string(),
      z.number(),
      z.boolean(),
      z.array(z.string()),
      z.array(z.record(z.string(), z.unknown())),
      z.null(),
    ])
    .optional(),
);

export const getIntelligentInventoryOperationDiff = {
  name: "getIntelligentInventoryOperationDiff" as const,
  input: z.object({ toolCallId: z.string() }),
  output: z.object({
    operations: z.array(
      z.object({
        id: z.coerce.string(),
        entityId: z.coerce.string(),
        entityType: z.string(),
        displayName: z.string(),
        changeKind: z.enum(["create", "update", "delete"]),
        classification: z.enum([
          "clean",
          "conflict",
          "already-gone",
          "already-undone",
        ]),
        oldValues: DiffValuesSchema_.nullable(),
        newValues: DiffValuesSchema_.nullable(),
        currentValues: DiffValuesSchema_.nullable(),
      }),
    ),
  }),
};
